import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { common, Hub } from '@qwyk/models';

import * as PortalTeamsActions from './portal-teams.actions';

export const PORTALTEAMS_FEATURE_KEY = 'portalTeams';

export interface State extends EntityState<Hub.CustomerTeam> {
    selectedId?: string; // which PortalTeams record has been selected
    loaded: boolean; // has the PortalTeams list been loaded
    loading: boolean;
    pagination?: common.PaginationMeta;
    error?: string | null; // last none error (if any)
}

export interface PortalTeamsPartialState {
    readonly [PORTALTEAMS_FEATURE_KEY]: State;
}

export const portalTeamsAdapter: EntityAdapter<Hub.CustomerTeam> =
    createEntityAdapter<Hub.CustomerTeam>();

export const initialState: State = portalTeamsAdapter.getInitialState({
    // set initial required properties
    loaded: false,
    loading: false,
});

const portalTeamsReducer = createReducer(
    initialState,
    on(PortalTeamsActions.loadPortalTeams, state => ({
        ...state,
        loaded: false,
        loading: true,
        error: null,
    })),
    on(
        PortalTeamsActions.loadPortalTeamsSuccess,
        (state, { portalTeams, pagination }) =>
            portalTeamsAdapter.setAll(portalTeams, {
                ...state,
                loaded: true,
                loading: false,
                pagination,
            })
    ),
    on(PortalTeamsActions.loadPortalTeamsFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false,
    })),
    on(PortalTeamsActions.loadPortalTeamSuccess, (state, { portalTeam }) => {
        return portalTeamsAdapter.upsertOne(portalTeam, state)
    }),
    on(PortalTeamsActions.selectPortalTeam, (state, { id }) => ({
        ...state,
        selectedId: id,
    })),
    // eslint-disable-next-line no-empty-pattern
    on(PortalTeamsActions.createPortalTeam, (state, {}) => ({
        ...state,
        loading: true,
        error: null,
    })),
    // eslint-disable-next-line no-empty-pattern
    on(PortalTeamsActions.updatePortalTeam, (state, {}) => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(PortalTeamsActions.createPortalTeamSuccess, (state, { portalTeam }) =>
        portalTeamsAdapter.addOne(portalTeam, {
            ...state,
            loading: false,
        })
    ),
    on(PortalTeamsActions.updatePortalTeamSuccess, (state, { portalTeam }) =>
        portalTeamsAdapter.updateOne(
            { id: portalTeam.id, changes: portalTeam },
            {
                ...state,
                loading: false,
            }
        )
    ),
    on(
        PortalTeamsActions.createPortalTeamFailure,
        PortalTeamsActions.updatePortalTeamFailure,
        (state, { error }) => ({
            ...state,
            loading: false,
            error,
        })
    )
);

export function reducer(state: State | undefined, action: Action) {
    return portalTeamsReducer(state, action);
}
